import { createTheme } from "@mui/material/styles";

/**
 * Jotun palette for eventId 5087644490
 * #002164 (0,33,100) - primary blue
 * #f0ad00 (240,173,0) - gold
 * #ffffff - white
 * #d62718 (214,39,24) - red
 */
const jotunPalette = {
  primary: { main: "#002164", contrastText: "#ffffff" },
  secondary: { main: "#f0ad00", contrastText: "#002164" },
  error: { main: "#d62718" },
  background: { default: "#f5f5f5", paper: "#ffffff" },
};

export const jotunLightTheme = createTheme({
  palette: {
    mode: "light",
    ...jotunPalette,
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: { borderRadius: 8 },
});

export const jotunDarkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#5a8fd4", contrastText: "#fff" },
    secondary: { main: "#f0ad00", contrastText: "#002164" },
    error: { main: "#d62718" },
    background: { default: "#121212", paper: "#1e1e1e" },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: { borderRadius: 8 },
});
